export const driversType = [
  { value: '-1', text: '' },
  { value: '0', text: 'Motorista' },
  { value: '1', text: 'Manutencao' },
  { value: '2', text: 'Treinador' },
  { value: '3', text: 'Administrador' },
];

export const getDriverType = (type) => driversType.find((item) => item.value === type.toString()).text;
